import { convertToTokeetEmail, rentalEmailPrefixFromName } from '../../functions'
import {
  UpdateRentalInstructionsPayload,
  UpdateRentalDetailsPayload,
  UpdateRentalCustomPayload,
  CreateRentalPayload,
} from './rental.interfaces'
import { Rental } from './rental.models'

export function getRentalBasicInfoPayload(rental: Rental): CreateRentalPayload {
  const address = rental.address
  return {
    address: {
      address: address.address,
      city: address.city,
      country: address.country,
      state: address.state,
      country_code: address.countryCode,
      zip: address.postalCode || address.zip,
    },
    name: rental.name,
    display_name: rental.displayName,
    nickname: rental.nickname,
    email: rental.email,
    phone: rental.phone,
    color: rental.color,
    gps: rental.gps,
    currency: rental.currency,
    attributes: {
      ...rental.attributes,
      registration: rental.attributes?.registration,
    },
  }
}

export function getRentalInstructionsPayload(rental: Rental): UpdateRentalInstructionsPayload {
  return {
    checkin: rental.checkin,
    checkout: rental.checkout,
    instructions: rental.instructions,
    specifics: rental.specifics as any,
    payment_instructions: rental.payment_instructions,
    payment_terms: rental.payment_terms,
  }
}

export function getRentalDetailsPayload(rental: Rental): UpdateRentalDetailsPayload {
  return {
    type: rental.type,
    checkin_type: rental.checkin_type,
    description: rental.description,
    locale: rental.locale,
    bedrooms: rental.bedrooms,
    bathrooms: rental.bathrooms,
    sleep_min: rental.sleepMin,
    sleep_max: rental.sleepMax,
    size: rental.size,
    size_metric: rental.sizeMetric,
    guest_minimum_age: rental.guest_minimum_age,
    children_allowed: rental.children_allowed,
    events_allowed: rental.events_allowed,
    smoking_allowed: rental.smoking_allowed,
    pets_allowed: rental.pets_allowed,
    detail: rental.detail,
    // attributes: rental.attributes,
  }
}

export function getRentalCustomInfoPayload(rental: Rental): UpdateRentalCustomPayload {
  return {
    custom1: rental.custom1,
    custom2: rental.custom2,
    custom3: rental.custom3,
    custom4: rental.custom4,
    custom5: rental.custom5,
  }
}

export function createRentalPayloadFromMainUnit(
  mainRental: Rental,
  unitName: string,
  subDomain: string
): CreateRentalPayload {
  const address = mainRental.address
  return {
    ...getRentalCustomInfoPayload(mainRental),
    ...getRentalDetailsPayload(mainRental),
    ...getRentalInstructionsPayload(mainRental),
    // taxes: mainRental.taxes,
    // payment_schedule: mainRental.payment_schedule,
    name: unitName,
    address: {
      address: address.address,
      city: address.city,
      country: address.country,
      state: address.state,
      country_code: address.countryCode,
      zip: address.postalCode || address.zip,
    },
    baserate: mainRental.baseRate,
    currency: mainRental.currency,
    checkin: mainRental.checkin,
    checkout: mainRental.checkout,
    phone: mainRental.phone,
    email: convertToTokeetEmail(rentalEmailPrefixFromName(unitName), subDomain),
    multi_unit_id: mainRental.id,
    color: mainRental.color,
    gps: mainRental.gps,
  }
}
